export class PedidoErpCambiado {
    pedidoId?:number;
    pedidoDetalleId? : number;
    codigoErpNuevo? : number;
    usuarioId? : number;
    observaciones? : string;
    
}